import { memo } from 'react'

import { CtaHandler } from '@/components/assistant/messages/CtaHandler'
import { MessageHandler } from '@/components/assistant/messages/MessageHandler'
import { ProcessingMessageHanlder } from '@/components/assistant/messages/ProcessingMessageHandler'
import { TasksHandler } from '@/components/assistant/messages/TasksHandler'
import { TipsHandler } from '@/components/assistant/messages/TipsHandler'
import { AssistantFeedItem } from '@/store/assistant'

type FeedItemRendererProps = {
  feed: AssistantFeedItem[]
  index: number
  isThinking: boolean
  item: AssistantFeedItem
}

export const FeedItemRenderer = memo(function ({
  feed,
  index,
  isThinking,
  item,
}: FeedItemRendererProps) {
  switch (item.type) {
    case 'tips':
      return <TipsHandler key={item.id} tips={item.tips} />
    case 'cta':
      return <CtaHandler key={item.id} index={index} isThinking={isThinking} item={item} />
    case 'processingMessage':
      return <ProcessingMessageHanlder key={item.id} isThinking={isThinking} item={item} />
    case 'message':
      return <MessageHandler key={item.id} item={item} />
    case 'tasks':
      return (
        <TasksHandler
          key={item.id}
          feed={feed}
          generatedTasks={item.tasks}
          isThinking={isThinking}
        />
      )

    case 'task': // Assuming 'task' and 'tip' alone should not render
    case 'tip':
    default:
      return null
  }
})
